var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('SiteHeader',{attrs:{"active":_vm.active}}),_c('main',{staticClass:"page-main"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }